<template>
  <div  class="d-flex align-items-center">
    <!-- TODO: refactor markup User Data Component-->
    <ul class="no-style-list">
    <li>
       <small><b class="user-info">{{userData.title}} {{userData.fname}} {{userData.lname}}</b> </small>
    </li>
    <li class=" text-center">
      <small><i><b class="user-info">{{userData.name}}</b></i></small>
    </li>
  </ul>
    <!-- <small class="user-name p-0 m-0">{{ userData.fname }} {{ userData.lname }} / {{ userData.companyName }}</small> -->
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'

export default {
  mixins: [authMixin]
}
</script>
